import { devicesDataState, devicesState } from '@/store/deviceInfo'
import { DeviceTestClass } from '@/utils/testDevice'
import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import { Fragment, useEffect, useRef, useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { useSetRecoilState } from 'recoil'
import Modal from '../Modal'
import PopUp from '../PopUp'
import cameraAudio from './audio/camera.mp4'
import mikeAudio from './audio/mike.mp4'
import voiceAudio from './audio/voice.mp3'
import wifiAudio from './audio/wifi.mp4'
import TestCamera from './components/TestCamera'
import { TestConfirmHotLine, TestConfirmStop } from './components/TestConfirm'
import TestMike from './components/TestMike'
import TestResult from './components/TestResult'
import TestStart from './components/TestStart'
import TestStep from './components/TestStep'
import TestVoice from './components/TestVoice'
import TestWifi from './components/TestWifi'

interface IProps {
  testing?: boolean
  fromPage: string
  cancel: () => void
  inRoom?: () => void
}

export const stepAnimate = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
  transition: {
    duration: 0.35,
    type: 'spring',
    damping: 35,
    stiffness: 600
  }
}

export interface AudioPauseType {
  link?: string
  wait?: number | null
  first?: boolean
}
export interface TestingDataType {
  voice: boolean
  mike: boolean
  camera: boolean
  wifi: boolean
}

let audioTimer: string | number | NodeJS.Timeout | undefined = undefined
let audioWait: string | number | NodeJS.Timeout | undefined = undefined
export default ({ testing = true, fromPage = '', cancel, inRoom: fatherInRoom }: IProps) => {
  const setRecoilDevices = useSetRecoilState(devicesState)
  const setRecoilDevicesData = useSetRecoilState(devicesDataState)
  const [deviceInstance, setdeviceInstance] = useState<any>(null)
  const [testingDisplay, settestingDisplay] = useState<boolean>(testing)
  const [confirmStop, setconfirmStop] = useState<boolean>(false)
  const [confirmHotLine, setconfirmHotLine] = useState<boolean>(false)
  const [ip, setip] = useState<string | null>(null)
  const [os, setos] = useState<string | null>(null)
  const [version, setversion] = useState<string>('0.0.0')
  const [testingRetest, settestingRetest] = useState<string>('')
  const [stepActive, setstepActive] = useState<number>(0)
  const [audioPause, setaudioPause] = useState<AudioPauseType | {}>({})
  const [testingData, settestingData] = useState<TestingDataType>({
    voice: false,
    mike: false,
    camera: false,
    wifi: false
  })
  const [audioSrc, setaudioSrc] = useState<string>(voiceAudio)
  const [type, settype] = useState<string>('start')
  const [deviceShow, setdeviceShow] = useState<boolean>(false)
  const music = useRef<any>(null)

  const init = () => {
    const instance = new DeviceTestClass()
    instance.init()
    setdeviceInstance(instance)
  }

  useEffect(() => {
    if (deviceInstance) {
      getDevicesInfo()
      checkDeviceChange()
    }
  }, [deviceInstance])

  useEffect(() => {
    let link = ''
    let wait = null
    let first = false

    switch (stepActive) {
      case 0:
        settype('start')
        break
      case 1:
        link = voiceAudio
        wait = 3000
        first = true
        settype('voice')
        break
      case 2:
        link = mikeAudio
        wait = 4000
        settype('mike')
        break
      case 3:
        link = cameraAudio
        wait = 3000
        settype('camera')
        break
      case 4:
        link = wifiAudio
        wait = 3000
        settype('wifi')
        break
      case 5:
        link = ''
        wait = null
        settype('result')
        console.log('检测结果', testingData)
        break
      default:
        break
    }
    audioPlay(link, wait, first)
  }, [stepActive])

  useEffect(() => {
    if (!testingDisplay) {
      audioPlay('')
    }
  }, [testingDisplay])

  // 检测事件
  const checkDeviceChange = () => {
    deviceInstance.on('onDeviceChanged', () => {
      console.log('-- 检测  设备变化---')
      if (stepActive > 0) {
        setdeviceShow(true)
      } else {
        getDevicesInfo()
      }
    })
    console.log('-- 1111111111检测  设备变化---', deviceInstance)
  }
  // 获取设备检测信息
  const getDevicesInfo = async () => {
    const allDevices = await deviceInstance.getDevices()
    console.log('设备检测获取到的设备:', allDevices)
    setDevices(allDevices)
  }
  const setDevices = (devices: never[]) => {
    console.log('setDevices', devices)
    if (devices && Array.isArray(devices)) {
      setRecoilDevices(devices)
    } else {
      setRecoilDevicesData(devices)
    }
  }
  // 设备改变 确认
  const deviceChange = () => {
    setdeviceShow(false)
    feedback(-1)
  }
  // 每项点击下一步
  const feedback = (step: number, status: boolean = false) => {
    if (!deviceInstance && step === 0) {
      init()
    }
    if (step || step === 0) {
      setstepActive(step + 1)
      // 开始检测之后存入每步的成功与否，供显示步骤组件使用
      switch (step) {
        case 1:
          settestingData((v) => ({
            ...v,
            voice: status
          }))
          break
        case 2:
          settestingData((v) => ({
            ...v,
            mike: status
          }))
          break
        case 3:
          settestingData((v) => ({
            ...v,
            camera: status
          }))
          break
        case 4:
          settestingData((v) => ({
            ...v,
            wifi: status
          }))
          break
        case -1:
          deviceInstance.leave()
          const instance = new DeviceTestClass()
          instance.init()
          setdeviceInstance(instance)
          getDevicesInfo()
          checkDeviceChange()
          console.log('----重新检测---')
          settestingData({
            // ...this.testingData,
            voice: false,
            mike: false,
            camera: false,
            wifi: false
          })
          break
        default:
          settestingData({
            // ...this.testingData,
            voice: false,
            mike: false,
            camera: false,
            wifi: false
          })
          break
      }
    }
  }
  // 自动播放
  const audioPlay = (link?: string, wait?: number | null | undefined, first?: boolean | undefined) => {
    const audio = music.current
    if (!audio) return
    audio.pause()
    clearTimeout(audioWait)
    clearTimeout(audioTimer)
    if (link !== '') {
      setaudioPause({ link, wait, first })
    }
    if (first) {
      // 首次播放欢迎语
      // audio.currentTime = 0
      // audio.play()
      audioPlay(link, wait)
      return
    }
    if (link) {
      console.log('audio src change :', link)
      audio.src = link
      audio.currentTime = 0
      const playPromise = audio.play()
      playPromise.catch((error: any) => {
        console.log('Auto-play was prevented :', error)
      })
      if (wait) {
        audioWait = setTimeout(() => {
          audioTimer = setTimeout(() => {
            audioPlay(link, wait)
          }, 5000)
        }, wait)
      }
    }
  }
  // 返回按钮
  const beforeOff = () => {
    if (stepActive === 5) {
      offTesting()
      return
    }
    setconfirmStop(true)
  }
  // 退出时的弹框
  const offTesting = () => {
    console.log('run close')
    deviceInstance && deviceInstance.leave()
    setconfirmStop(false)
    setTimeout(cancel, 300)
  }
  const close = () => {
    cancel()
  }
  // 进入教室
  const inRoom = () => {
    deviceInstance && deviceInstance.leave()
    fatherInRoom && fatherInRoom()
  }

  const testProps = {
    testingRetest: testingRetest,
    rtcEngine: deviceInstance,
    testingData: testingData,
    fromPage: fromPage,
    next: feedback,
    off: offTesting,
    hotLine: () => setconfirmHotLine(true),
    inRoom: inRoom
  }
  return (
    <Container>
      <div style={testingDisplay ? {} : { display: 'none' }} className="equipment-testing">
        <div style={testingDisplay ? {} : { display: 'none' }} className="content" id="content">
          <IoClose className="text-[#999] text-[30px] absolute top-[12px] right-[12px] hover:text-[#666] hover:scale-105 hover:cursor-pointer active:scale-95 transition" onClick={beforeOff} />
          <div className="equipment-body">
            <div className="content-title">设备检测</div>
            <TestStep stepActive={stepActive} testingData={testingData} />
            <AnimatePresence>
              {type === 'start' ? <TestStart {...testProps} /> : null}
              {type === 'voice' ? <TestVoice {...testProps} /> : null}
              {type === 'mike' ? <TestMike {...testProps} /> : null}
              {type === 'camera' ? <TestCamera {...testProps} /> : null}
              {type === 'wifi' ? <TestWifi {...testProps} /> : null}
              {type === 'result' ? <TestResult {...testProps} /> : null}
            </AnimatePresence>
          </div>
        </div>

        <Modal show={confirmStop} className="h-[280px]">
          <TestConfirmStop off={offTesting} handleStop={() => setconfirmStop(false)} />
        </Modal>
        <Modal show={confirmHotLine}>
          <TestConfirmHotLine handleHotLine={() => setconfirmHotLine(false)} />
        </Modal>

        <audio ref={music} src={audioSrc}>
          <source type="audio/ogg" />
        </audio>
      </div>
      {deviceShow ? (
        <div className="device-dialog-mask">
          <div className="device-dialog-box">
            <PopUp className="dialog-exit-class" title="提示" type="confirm" confirm={deviceChange} cancel={() => setdeviceShow(false)}>
              <Fragment>检测到您的镜头或麦克风发生改变,是否重新检测</Fragment>
            </PopUp>
          </div>
        </div>
      ) : null}
    </Container>
  )
}

const Container = styled(motion.div)`
  width: 856px;
  height: 600px;
  .device-dialog {
    &-mask {
      position: fixed;
      z-index: 2000;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);
    }
    &-box {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      // position:absolute;
      // left:50%;
      // top:50%;
      // margin-top: -30vh;
      // transform: translateX(-50%);
    }
  }

  .equipment-testing {
    height: 100%;
    // background: rgba(255, 255, 255, 0.25);
    // border-radius: 25px;
    // padding: 8px;
    box-sizing: border-box;
    // position: absolute;
    border-radius: 12px;
    box-shadow: 0px 0px 0px 4px rgba(255, 255, 255, 0.25);
    .content {
      width: 856px;
      // height: 41.75vw;
      border-radius: 12px;
      background: #fff;
      height: 100%;
      position: relative;
      overflow: hidden;
      // padding-bottom:4vw;
      // box-sizing: border-box;
      .equipment-body {
        // overflow-y: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        /* padding-bottom: 15px; */
        // box-sizing: border-box;
        // max-height: 5vw;
      }
      .close {
        position: absolute;
        /* color: #cccccc; */
        right: 18px;
        top: 14px;
      }
      &-title {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        height: 90px;
        line-height: 90px;
        font-weight: 500;
        text-align: center;
      }
      .alls-testing {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 0 60px;
        flex: 1;
        .base-tips {
          height: 12px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 15px 0 5px 0;
        }
        .base-img {
          width: 250px;
          height: 200px;
          background-position: 0 0;
          background-size: 100% 100%;
        }
        .base-title {
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 16px 0 2vw 0;
        }
        .base-btn {
          // position:absolute;
          // left: 50%;
          // bottom:-10px;
          // transform: translateX(-50%);
          width: 242px;
          height: 48px;
          border-radius: 24px;
          color: #fff;
          text-align: center;
          line-height: 48px;
          font-size: 18px;
          font-weight: 500;
          cursor: pointer;
          margin: 0 40px;
        }
      }
    }
  }
`
